import { Alert } from 'antd';

const MAX_SHIPMENTS_FOR_SIMULATION_WARNING = 300_000;
const MAX_SHIPMENTS_FOR_SIMULATION = 500_000;

const ShipmentSizeAlert = ({ totalShipments }: { totalShipments: number }) => {
  if (totalShipments > MAX_SHIPMENTS_FOR_SIMULATION) {
    return (
      <Alert
        message="Too Many Shipments"
        description="Your shipment count exceeds the maximum allowed for simulation. Please reduce your sampling percentage."
        type="error"
        showIcon
      />
    );
  }
  if (totalShipments > MAX_SHIPMENTS_FOR_SIMULATION_WARNING) {
    return (
      <Alert
        message="Warning"
        description="You are selecting a large number of shipments for simulation. This may take a long time to run. Consider reducing your sampling percentage."
        type="warning"
        showIcon
      />
    );
  }
  return null;
};

export const useShipmentSizeAlert = ({ totalShipments }: { totalShipments: number }) => {
  return {
    ShipmentSizeAlert: () => <ShipmentSizeAlert totalShipments={totalShipments} />,
    exceededMaxShipments: totalShipments > MAX_SHIPMENTS_FOR_SIMULATION,
  };
};
